<script>
    export let fill="#000000";
    export let height="16px";
    export let width="16px";
	export let padding = "1em";

</script>
<div style="padding: {padding};" aria-hidden="true" >
	<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
		 width="{width}" height="{height}" viewBox="0 0 428.897 428.896"
		 xml:space="preserve">
<g>
	<g>
		<path style="fill:{fill};" d="M379.936,163.513c-0.034-0.521-0.131-1.024-0.303-1.516c-0.068-0.188-0.114-0.363-0.194-0.543
			c-0.286-0.624-0.646-1.212-1.149-1.716L220.261,1.71c-0.504-0.503-1.087-0.86-1.707-1.141c-0.184-0.089-0.369-0.135-0.563-0.2
			c-0.486-0.163-0.972-0.263-1.48-0.292C216.375,0.066,216.258,0,216.129,0H54.747c-3.23,0-5.855,2.625-5.855,5.855v417.186
			c0,3.236,2.625,5.855,5.855,5.855H374.15c3.242,0,5.854-2.619,5.854-5.855V163.878
			C380.004,163.747,379.942,163.638,379.936,163.513z M221.976,19.984l69.028,69.017l69.016,69.014H221.976V19.984z M60.603,417.181
			V11.705h149.666v152.173c0,3.231,2.622,5.855,5.855,5.855h152.171v247.447H60.603z"/>
	</g>
	<g>
		<rect x="107.59" y="208.587" style="fill:{fill};" width="213.719" height="11.71"/>
	</g>
	<g>
		<rect x="107.59" y="255.43" style="fill:{fill};" width="213.719" height="11.71"/>
	</g>
	<g>
		<rect x="107.59" y="302.271" style="fill:{fill};" width="213.719" height="11.711"/>
	</g>
	<g>
		<rect x="107.59" y="349.113" style="fill:{fill};" width="213.719" height="11.711"/>
	</g>
</g>
</svg>
</div>